// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2DiW7","rootSuccess":"CompleteLink_rootSuccess__wpGNk","rootFailure":"CompleteLink_rootFailure__3qsB_","isDisabled":"CompleteLink_isDisabled__MZa67"};